export default "__VITE_ASSET__B54lR3rv__"